import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

// Fade-up on scroll into view
export const Reveal = ({ children, delay = 0, y = 40, className = "", ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.8, delay, ease: EASE }}
    {...rest}
  >
    {children}
  </motion.div>
);

// Masked line: text slides up from behind an overflow-hidden mask
export const MaskLine = ({ children, delay = 0, className = "" }) => (
  <span className="block overflow-hidden pb-[0.12em]">
    <motion.span
      className={`block ${className}`}
      initial={{ y: "110%" }}
      animate={{ y: "0%" }}
      transition={{ duration: 0.9, delay, ease: EASE }}
    >
      {children}
    </motion.span>
  </span>
);

// Section eyebrow / overline
export const Overline = ({ children, color = "#1A1A24", className = "" }) => (
  <div className={`flex items-center gap-3 ${className}`}>
    <span className="h-2 w-2 rounded-full" style={{ backgroundColor: color }} />
    <span className="text-xs font-bold uppercase tracking-[0.28em]" style={{ color }}>
      {children}
    </span>
  </div>
);
